/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Type_FilterInputs */

const en_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Type Filter`)
};

const fr_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtre par type de tâche`)
};

const de_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobtypfilter`)
};

const it_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro tipo di lavoro`)
};

const ru_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр по типу работы`)
};

const es_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro de tipo de trabajo`)
};

const zh_cn2_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`职位类型筛选器`)
};

const ja_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`求人種別フィルター`)
};

const hi_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी प्रकार फ़िल्टर`)
};

const pt_pt2_job_type_filter = /** @type {(inputs: Job_Type_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro por tipo de trabalho`)
};

/**
* | output |
* | --- |
* | "Job Type Filter" |
*
* @param {Job_Type_FilterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_type_filter = /** @type {((inputs?: Job_Type_FilterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Type_FilterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_job_type_filter(inputs)
	if (locale === "de") return de_job_type_filter(inputs)
	if (locale === "it") return it_job_type_filter(inputs)
	if (locale === "ru") return ru_job_type_filter(inputs)
	if (locale === "es") return es_job_type_filter(inputs)
	if (locale === "zh-CN") return zh_cn2_job_type_filter(inputs)
	if (locale === "ja") return ja_job_type_filter(inputs)
	if (locale === "hi") return hi_job_type_filter(inputs)
	if (locale === "pt-PT") return pt_pt2_job_type_filter(inputs)
	return en_job_type_filter(inputs)
});